/**
 * Wireframe
 *
 * @author Gabriel Mandu <gabriel.mandu@check24.de>
 *
 * @module Common
 */
class Wireframe {
    constructor() {
        this._settings = {
            showAndStartChatbot: new CustomEvent('show-chatbot-launcher-and-start'),
            deviceoutput: 'desktop',
            chatbot: {
                trigger: 'energy-chatbot-trigger',
                component: 'c24-pbe-chatbot-component',
                contactIcon: 'c24m-contact-icon',
                contactLayer: 'chatty-chatbot-layer',
                mobileContactLayer: '.c24m-contact-layer',
                mobileBlockingLayer: 'c24m-page-blocking-layer',
                mobileContact: '.c24m-contact-wrapper',
                desktopContact: '.c24-contact'
            },
        };
    }

    initDesktop() {
        this._settings.deviceoutput = 'desktop';
        this._onDesktopContactClick();
    }

    initMobile() {
        this._settings.deviceoutput = 'mobile';
        this._onMobileContactClick();
    }

    hideBubble() {
        const $chatbotElem = document.getElementsByTagName(this._settings.chatbot.component)[0];
        if ($chatbotElem) {
            $chatbotElem.style.visibility = 'hidden';
        }
    }

    showBubble() {
        const $chatbotElem = document.getElementsByTagName(this._settings.chatbot.component)[0];
        if ($chatbotElem) {
            $chatbotElem.style.visibility = 'visible';
        }
    }

    /**
     * Handles chat start click
     *
     * @private
     */
    _onDesktopContactClick() {
        const $desktopChatStartButton = document.querySelector(this._settings.chatbot.desktopContact);

        if ($desktopChatStartButton) {
            $desktopChatStartButton.addEventListener('click', () => {
                this.showBubble();
                document.dispatchEvent(this._settings.showAndStartChatbot);
            });
        }
    }

    _onMobileContactClick() {

        const $mobileChatStartButton = document.querySelector(this._settings.chatbot.mobileContact);

        if ($mobileChatStartButton){
            $mobileChatStartButton.addEventListener('click', () => {
                document.querySelector(this._settings.chatbot.mobileContactLayer).removeAttribute('style')

                const mobileBlockingLayer = document.getElementById(this._settings.chatbot.mobileBlockingLayer);
                if (!mobileBlockingLayer) {
                    return;
                }
                mobileBlockingLayer.click();

                this.showBubble();
                document.dispatchEvent(this._settings.showAndStartChatbot);
            });
        }
    }
}

export default Wireframe;
